<template>
  <div class="el-tabs__inner">
    <draggable
      :list="fields"
      :clone="clone"
      class="dragArea row justify-center"
      :group="{ name: 'formbuilder', pull: 'clone', put: false }"
      :sort="false"
      :move="onMove"
    >
      <template v-for="(field, index) in fields">
        <v-col class :key="index" cols="5">
          <span
            @dblclick="clone(field)"
            class="badge button__sidebar v-btn v-btn--contained theme--light v-size--default font-weight-bold"
            >{{ $t(field.text) }}</span
          >
        </v-col>
      </template>
    </draggable>
  </div>
</template>


<script>
import { FormBuilder } from "@/components/form_elements_gramma/formbuilder";
// import draggable from "vuedraggable";
export default {
  name: "Elements",
  store: ["activeFieldGrammar", "activeTabForFieldsGrammar", "tab"],
  components: FormBuilder.$options.components,
  data() {
    return {
      editable: true,
      isDragging: false,
      delayedDragging: false,
      fields: FormBuilder.$data.fields,
      dropElementOptions: FormBuilder.$data.dropElementOptions,
    };
  },

  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    clone(field) {
      console.log("field: ", field);
      return this._.cloneDeep(field);
    },
    onMove({ relatedContext, draggedContext }) {
      console.log("---------------");
      console.log("relatedContext: ", relatedContext);
      console.log("draggedContext: ", draggedContext);
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    handleDBClick(field) {
      this.editElementProperties(field);
    },
    async editElementProperties(field) {
      if (field.type == "image") {
        this.activeFieldGrammar = {};
        this.activeTabForFieldsGrammar = "elements";
      } else {
        this.tab = "properties";
      }
      FormBuilder.editElementProperties(field);
    },
  },
};
</script>

<style lang="scss" scoped>
.button__sidebar {
  width: 100%;
  //   margin-bottom: 5px;

  .is-disabled & {
    opacity: 0.4;
  }
}

// Display this ghost in <main> only
.sortable__ghost {
  position: relative;
  max-width: 140px;
  //   border-bottom: 2px solid #3a8ee6;
  margin-top: -10px;
  //   margin-bottom: 2px;

  [type="button"] {
    display: none;
  }

  &:before {
    // content: "Drag it here";
    background-color: #ecf5ff;
    // color: #3a8ee6;
    position: absolute;
    // left: 50%;
    font-size: 10px;
    border-radius: 10px;
    // line-height: 15px;
    // padding: 0 10px;
    // top: -6px;
    transform: translateX(-50%);
  }
}
.pointer {
  cursor: pointer;
}
</style>
